var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8333 7.44277C18.8333 6.93792 18.8333 6.6855 18.7335 6.56861C18.6469 6.46719 18.5169 6.41337 18.384 6.42383C18.2307 6.43589 18.0522 6.61438 17.6953 6.97136L14.6667 9.99996L17.6953 13.0286C18.0522 13.3855 18.2307 13.564 18.384 13.5761C18.5169 13.5866 18.6469 13.5327 18.7335 13.4313C18.8333 13.3144 18.8333 13.062 18.8333 12.5572V7.44277Z",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16667 8.16663C2.16667 6.76649 2.16667 6.06643 2.43916 5.53165C2.67884 5.06124 3.06129 4.67879 3.5317 4.43911C4.06647 4.16663 4.76654 4.16663 6.16667 4.16663H10.6667C12.0668 4.16663 12.7669 4.16663 13.3016 4.43911C13.7721 4.67879 14.1545 5.06124 14.3942 5.53165C14.6667 6.06643 14.6667 6.76649 14.6667 8.16663V11.8333C14.6667 13.2334 14.6667 13.9335 14.3942 14.4683C14.1545 14.9387 13.7721 15.3211 13.3016 15.5608C12.7669 15.8333 12.0668 15.8333 10.6667 15.8333H6.16667C4.76654 15.8333 4.06647 15.8333 3.5317 15.5608C3.06129 15.3211 2.67884 14.9387 2.43916 14.4683C2.16667 13.9335 2.16667 13.2334 2.16667 11.8333V8.16663Z",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.19b557da9046a08daaa4bba103fcd777.svg";
export { ForwardRef as ReactComponent };